import React, {Component} from "react";
import {Checkbox, DatePicker} from "antd";
import Constants from "../../../../services/Constants";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {appliedFilters} from "../../../../selectors/fetchInterventions";
import moment from "moment";

const CheckboxGroup = Checkbox.Group;
const DATE_FORMAT = Constants.DATE_FORMAT_DISPLAY;
const DATE_FORMAT_API = Constants.DATE_FORMAT_API;

class FilterDate extends Component {

  dateOnChange = (apiKey, zonedTime, filter) => {
    const date = (zonedTime === null) ? [] : zonedTime.format(DATE_FORMAT_API);
    this.filterOnChange(apiKey, date, filter);
  };

  filterOnChange = (apiKey, checkedValues, filter) => {
    filter.selectedKeys[0] = checkedValues;
    (checkedValues && checkedValues.length > 0) ? filter.confirm() : filter.clearFilters();
    const map = {};
    map[apiKey] = checkedValues;
    this.props.contentUpdater(map);
  };

  render = () => {
    const {intl: {formatMessage}, apiKeyStart, apiKeyEnd, filter} = this.props;

    const startDate = (this.props.appliedFilters || {})[apiKeyStart] && typeof this.props.appliedFilters[apiKeyStart] === 'string' ? moment(this.props.appliedFilters[apiKeyStart]) : undefined;
    const endDate = (this.props.appliedFilters || {})[apiKeyEnd] && typeof this.props.appliedFilters[apiKeyEnd] === 'string' ? moment(this.props.appliedFilters[apiKeyEnd]) : undefined;

    return (
      <CheckboxGroup className="dropdown dropdown--sm dropdown--bottom-right">
        <DatePicker placeholder={formatMessage({id: 'placeholder.startDate'})} format={DATE_FORMAT}
                    onChange={(zonedTime) => this.dateOnChange(apiKeyStart, zonedTime, filter)}
                    value={startDate}
        />
        <DatePicker placeholder={formatMessage({id: 'placeholder.endDate'})} format={DATE_FORMAT}
                    onChange={(zonedTime) => this.dateOnChange(apiKeyEnd, zonedTime, filter)}
                    value={endDate}
        />
      </CheckboxGroup>
    );
  }
}

const mapStateToProps = state => ({
  appliedFilters: appliedFilters(state),
});

export default connect(mapStateToProps)(injectIntl(FilterDate));



// WEBPACK FOOTER //
// ./src/components/overview/table/filter/FilterDate.js